import { useSelector } from "react-redux";
import ModalDetailsRow from "../../../../../ModalDetailsRow/ModalDetailsRow.component";
import { ROLE_TYPES } from "../../../../../../helpers/roleTypes";
import { IAdminUserDetail } from "../../../../hooks/useGetAdminUser";
import { RootState } from "../../../../../../redux/store";

interface IDetailsTabProps {
  user: IAdminUserDetail;
  onCloseModal: () => void;
  onLockUnlock: () => void;
}

export default function DetailsTab({
  user,
  onCloseModal,
  onLockUnlock,
}: IDetailsTabProps) {
  const loggedInUser = useSelector(
    (state: RootState) => state?.authReducer?.loggedInUser,
  );
  const canLock = loggedInUser?.roles?.includes(ROLE_TYPES.USER_LOCK_INITIATOR);
  const canUnlock = loggedInUser?.roles?.includes(
    ROLE_TYPES.USER_UNLOCK_INITIATOR,
  );
  const showLockUnlockButton = user?.isLocked ? canUnlock : canLock;
  return (
    <form>
      <ModalDetailsRow
        label="Email"
        value={user?.email}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="First Name"
        value={user?.firstName}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Last Name"
        value={user?.lastName}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="User Name"
        value={user?.userName}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="User Type"
        value={user?.userType}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Phone Number"
        value={user?.phoneNumber}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Date Joined"
        value={user?.createdDate?.substring(0, 10)}
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Last Login"
        value={
          user?.lastLogin
            ? `${(user?.lastLogin).substring(0, 10)} / ${(user?.lastLogin).substring(11, 19)}`
            : "N/A"
        }
        icon="fas fa-user-circle"
      />
      <ModalDetailsRow
        label="Locked Status"
        value={user?.isLocked ? "Locked" : "Unlocked"}
        icon="fas fa-lock"
      />

      <ModalDetailsRow
        label="Unlock Approval Status"
        value={user?.unlockStatusText}
        icon="fas fa-user-shield"
      />

      <div className="Form__action-buttons m-t-1">
        {showLockUnlockButton && (
          <button
            type="button"
            className="btn zoom-element btn login-btn m-0 mr-auto"
            onClick={onLockUnlock}
          >
            <i
              className={`fas fa-${user?.isLocked ? "lock-open" : "lock"}`}
            ></i>
            &nbsp; {user?.isLocked ? "Unlock User" : "Lock User"}
          </button>
        )}
        <button
          type="button"
          className="btn zoom-element btn login-btn m-0 ml-auto"
          onClick={onCloseModal}
          data-dismiss="modal"
        >
          <i className="fas fa-times-circle"></i>
          &nbsp; Close
        </button>
      </div>
    </form>
  );
}
